export const MATCH_SCORE_RING_STROKE = 3
